import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalRepository } from '@shared/helper/local-repository';
import { TServiceResult } from '@shared/helper/t-service-result';
import { AchievementsModel } from '../models/achievements-model';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';

@Injectable({
  providedIn: 'root'
})
export class AchievementService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'achv');
  }

  getMyAchievements(termFilter: TermFilterModel): Observable<TServiceResult<PageList<AchievementsModel>>> {
    return this.http.post<TServiceResult<PageList<AchievementsModel>>>(`${this.apiUrl}/GetMyAchievements`, termFilter);
  }

  getMyLatestAchievements(termFilter: TermFilterModel): Observable<TServiceResult<PageList<AchievementsModel>>> {
    return this.http.post<TServiceResult<PageList<AchievementsModel>>>(`${this.apiUrl}/GetMyLatestAchievements`, termFilter);
  }

  getGuestAchievements(id: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<AchievementsModel>>> {
    return this.http.post<TServiceResult<PageList<AchievementsModel>>>(`${this.apiUrl}/GetGuestAchievements/${id}`, termFilter);
  }

  getGuestLatestAchievements(id: string, termFilter: TermFilterModel): Observable<TServiceResult<AchievementsModel>> {
    return this.http.post<TServiceResult<AchievementsModel>>(`${this.apiUrl}/GetGuestLatestAchievements/${id}`, termFilter);
  }

}
